import React, { Component } from 'react';
import { message } from 'antd';
import { replace } from 'lodash';
import Button from '../../Button';
import Anchor from '../../link/Anchor';
import { EXCEL_UPLOAD_TYPE } from '../../../constants/service/common/utilConstants';
import './ExcelUploadForm.scss';

const defaultExtension = ['.xls', '.xlsx'];

class ExcelUploadForm extends Component {
  onChange = (e) => {
    const { onChange, validExtension = defaultExtension } = this.props;

    e.preventDefault();
    let files;
    if (e.target) {
      files = e.target.files;
    }

    /**
     *  파일 존재 체크
     */
    if (!files || !files[0]) {
      e.target.value = null;
      return false;
    }

    const rexValidExtension = validExtension.map((item) => replace(item, '.', '')).join('|');

    const pattern = new RegExp(rexValidExtension);
    // 확장자는 대소문자를 구분하지 않는다 — 'UPLOAD.CSV' 같은 대문자 확장자도 유효한 파일이다
    const format = files[0].name.split('.').pop().toLowerCase();

    /**
     *  file 형식 체크
     */
    if (!pattern.test(format)) {
      message.error(`${validExtension} 파일을 올려주세요!!`);
      e.target.value = null;
      return false;
    }

    onChange(files[0]);

    e.target.value = null;
  };

  render() {
    const {
      btnText = '찾아보기',
      validExtension = defaultExtension,
      uploadType = EXCEL_UPLOAD_TYPE.BUTTON,
      dragAndDropSummaryText = '첨부할 파일을 끌어 놓거나, ',
      uploadLinkText = '찾아보기',
      fileName,
    } = this.props;

    return (
      <div className="form-excel-upload">
        {uploadType === EXCEL_UPLOAD_TYPE.BUTTON ? (
          <div className="form-excel-update-wrap">
            <Button isRadius={true} className="form-excel-upload-btn" color="primary" text={btnText} />

            <input type="file" className="file-input" accept={validExtension.join(',')} onChange={this.onChange} />
          </div>
        ) : null}
        {uploadType === EXCEL_UPLOAD_TYPE.DRAG_DROP ? (
          <div className="form-excel-update-drag-drop-wrap">
            <div className="summary-and-filename">{fileName ? fileName : dragAndDropSummaryText}</div>
            <Anchor className="upload-link" text={uploadLinkText} isUnderLine={true} color="primary" />
            <input type="file" className="file-input" accept={validExtension.join(',')} onChange={this.onChange} />
          </div>
        ) : null}
      </div>
    );
  }
}

export default ExcelUploadForm;
